<template>
    <div class="modal-content tw-text-left tw-px-6 tw-relative">
        <div class="tw-flex tw-justify-between tw-items-center tw-pb-6 tw-sticky tw-top-0 tw-left-0 tw-w-full tw-pt-6 tw-bg-white">
            <h4 class="tw-font-bold tw-text-lg">{{ $t('privacyPolicy.title') }}</h4>
            <div class="modal-close tw-cursor-pointer tw-z-50" @click="$store.dispatch('closeAllModals')">
                <svg class="tw-fill-current" xmlns="http://www.w3.org/2000/svg" width="17.639" height="17.567" viewBox="0 0 17.639 17.567"><g transform="translate(16.821 16.749) rotate(180)"><path d="M389.1,2434l7.28-7.282a.421.421,0,0,0,0-.6.425.425,0,0,0-.594,0l-7.281,7.283-7.281-7.283a.421.421,0,0,0-.595.6l7.281,7.282-7.281,7.281a.421.421,0,0,0,.6.6l7.281-7.281,7.281,7.281a.418.418,0,0,0,.3.123.421.421,0,0,0,.3-.719L389.1,2434Z" transform="translate(-380.503 -2426.001)" fill="#ccc" stroke="#ccc" stroke-width="1.5"/></g></svg>
            </div>
        </div>
        <div class="tw-max-h-3/4 tw-h-64 tw-overflow-y-auto">
            <p>Declaração de Privacidade</p>
            <p>Os dados são recolhidos pela KWANKO SA, colectiva nº440 546 885 R.C.S Nanterre e sede em 60 Boulevard Maréchal Joffre 92340 Bourg-La-Reine, subcontratante para efeitos de aplicação do Regulamento Geral da Proteção de Dados, que os recolhe por conta da&nbsp;MasterD .</p>
            <br>
            <p>A&nbsp;MasterD&nbsp;vê a privacidade dos dados como uma componente fundamental do seu negócio.</p>
            <br>
            <p>A&nbsp;MasterD&nbsp;processa e armazena dados pessoais dentro da União Europeia (UE) e demonstrará a qualquer momento obediência à legislação da UE assim como os nossos princípios explícitos neste documento.</p>
            <br>
            <p>Esta plataforma está orientada pelas normas do Regulamento Geral de Proteção de Dados, (Regulamento (UE) 2016/679), que é um ato legislativo diretamente vinculativo para pessoas singulares e coletivas que, sendo residentes ou não na EU, tratem dados de cidadãos da União Europeia.</p>
            <br>
            <p>A declaração de privacidade está sob responsabilidade da&nbsp;MasterD&nbsp;. O Encarregado de proteção de dados (DPO) garante o cumprimento do regulamento e está envolvido em todos os assuntos relacionados à proteção de dados pessoais. A sua identificação e modo de contacto estão indicados no final do presente documento.</p>
            <br>
            <p>A&nbsp;MasterD&nbsp;é considerada a responsável pelo tratamento de dados, para efeitos do RGPD, e determinará o propósito e os meios de processamento de dados pessoais apresentados e recolhido online.</p>
            <br>
            <br>
            <p>Princípios</p>
            <p>A nossa política de proteção de dados garante que os dados são:</p>
            <br>
            <p>Objeto de um tratamento lícito, leal e transparente em relação ao titular dos dados («licitude, lealdade e transparência»);</p>
            <br>
            <p>Recolhidos para finalidades determinadas, explícitas e legítimas e não podendo ser tratados posteriormente de uma forma incompatível com essas finalidades;</p>
            <br>
            <p>Adequados, pertinentes e limitados ao que é necessário relativamente às finalidades para as quais são tratados;</p>
            <br>
            <p>Exatos e atualizados sempre que necessário; sendo adotadas todas as medidas adequadas para que os dados inexatos, tendo em conta as finalidades para que são tratados, sejam apagados ou retificados sem demora;</p>
            <br>
            <p>Conservados de uma forma que permita a identificação dos titulares dos dados apenas durante o período necessário para as finalidades para as quais são tratados;</p>
            <br>
            <p>Tratados de uma forma que garanta a sua segurança, incluindo a proteção contra o seu tratamento não autorizado ou ilícito e contra a sua perda, destruição ou danificação acidental, adotando as medidas técnicas ou organizativas adequadas;</p>
            <br>
            <p>Recolha de dados pessoais</p>
            <p>Para melhorarmos a sua experiência de navegação e podermos oferecer-lhe os serviços que precisa no momento em que precisa teremos de recolher algumas informações. Fazemos questão que saiba como tratamos os dados que nos confiou.</p>
            <br>
            <p>Com a sua autorização, iremos recolher as seguintes informações :&nbsp;Nome, Apelido, Idade, Telefone, País, Email, Morada, Distrito, Habilitações.</p>
            <br>
            <p>O nosso website usa cookies ou tecnologias similares para garantir a melhor experiência de utilizador e para analisar tendências, rastrear o movimento de utilizadores dentro do website e recolher informações demográficas sobre a nossa base de utilizadores como um todo. Os nossos Cookies registam informação como endereço de Protocolo de Internet (IP), tipo de navegador, Provedor de Serviço de Internet (ISP), páginas de referência/saída, os arquivos acedidos no nosso site (por exemplo páginas HTML), sistemas operativos, data e hora, para analisar tendências no site.</p>
            <br>
            <p>Prazo de conservação:</p>
            <p>A KWANKO conservará os seus dados por 24 meses e a&nbsp;MasterD compromete-se a eliminá-los assim que for solicitado por si.</p>
            <br>
            <p>Menoridade</p>
            <p>Ao aceitar a presente política de privacidade garante ter idade igual ou superior a 16 anos.</p>
            <br>
            <p>Uso de dados pessoais</p>
            <p>A&nbsp;MasterD&nbsp;irá contactá-lo para que lhe apresentar os bens e/ou serviços que comercializa. O tratamento de tais dados funda-se no consentimento dado pelo titular dos dados. O acesso a dados pessoais é estritamente limitado ao pessoal dos responsáveis do tratamento de dados pessoais e subcontratantes.</p>
            <br>
            <p>Partilha de dados pessoais</p>
            <p>A&nbsp;MasterD&nbsp;garante que não tenciona transferir dados para países terceiros ao Regulamento Geral da Proteção de Dados e caso o faça, pedir-lhe- á para isso consentimento.</p>
            <p>A&nbsp;MasterD&nbsp;celebrou com a KWANKO um contrato pelo qual esta se obriga a não transferir dados para países terceiros.</p>
            <p>Em certas situações, tanto a&nbsp;MasterD&nbsp;como a Kwanko poderão ser notificadas para divulgar informações pessoais em resposta a pedidos por autoridades supervisão para preencher os requisitos do RGPD.</p>
            <br>
            <p>Segurança de processamento</p>
            <p>Nós processaremos dados pessoais de forma segura, aplicando e mantendo medidas técnicas e organizacionais para proteger dados pessoais contra destruição acidental ou ilícita, alteração, partilha ou acesso não autorizado, onde o processamento envolve a transmissão de dados por rede, e contra toda outra forma ilícita de processamento.</p>
            <br>
            <p>Acesso e retificação ou eliminação de dados pessoais</p>
            <p>Enquanto titular dos dados os utilizadores têm o direito a solicitar o acesso aos dados que lhe digam respeito, a pedir para os retificar e para os eliminar. Poderá ainda limitar o tratamento dado aos dados, bem como opor-se ao mesmo e ainda requerer a portabilidade dos dados.&nbsp;</p>
            <p>Poderá ainda pedir esclarecimentos junto do Encarregado da Proteção de dados ou apresentar reclamação junto da CNPD sempre que entenda que os seus direitos estão a ser violados.</p>
            <br>
            <p>Emails de marketing</p>
            <p>Os responsáveis pelo tratamento de dados têm a permissão, após consentimento explícito, para enviar emails de marketing para os utilizadores do site. A qualquer momento o utilizador poderá cancelar o consentimento através do link, existente para o efeito, em cada email enviado.</p>
            <br>
            <p>Responsabilidade</p>
            <p>A&nbsp;MasterD&nbsp;é responsável por, e será capaz de demonstrar a qualquer momento, a conformidade com o RGPD.</p>
            <br>
            <p>Mudanças a esta política</p>
            <p>Esta política poderá ser atualizada ocasionalmente, por exemplo devido às mudanças à legislação relevante. Se quaisquer mudanças materiais forem conduzidas, os clientes serão notificados por email ou por notificação no website.</p>
            <br>
            <p>Contatos</p>
            <br>
            <p>RESPONSÁVEL PELO TRATAMENTO</p>
            <p>MasterD&nbsp;</p>
            <p>Rua Dona Estefânia 84-A 1000-158 lisboa,&nbsp;</p>
            <p>Tel: 210 402 440&nbsp;</p>
            <p>E-mail: rgpd@masterd.pt.</p>
            <br>
            <p>SUBCONTRATANTE&nbsp;</p>
            <p>KWANKO&nbsp;</p>
            <p>Morada: 60 Boulevard Maréchal Joffre 92340 Bourg-La-Reine</p>
            <p>E-mail: gdpr@kwanko.com</p>
            <br>
            <p>ENCARREGADO DA PROTEÇÃO DE DADOS</p>
            <p>DPO KWANKO</p>
            <br>
            <h4><b>{{ $t('privacyPolicy.dataProcessor.title') }}</b></h4>
            <p>{{ $t('privacyPolicy.dataProcessor.text', { company:company }) }}</p>
        </div>
        <div class="terms-footer tw-sticky tw-bg-white tw-bottom-0 tw-py-6">
            <button type="button" class="btn-cta" @click.prevent="$store.state.privacyPolicy = true; $store.state.modal.terms = false;">
                {{ $t('privacyPolicy.accept') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Terms',
    data() {
        return {
            company: process.env.VUE_APP_COMPANY,
        };
    },
};
</script>

<style lang="scss" scoped>
.terms-footer {
    .btn-cta {
        max-width: 100%;
    }
}

</style>
